export default __webpack_public_path__ + "static/media/doinha.7ec29968.webp";